import * as core from '../../../../../../../core'

import { query } from './overview-donut.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.overview.widgets.donut',
    description: 'Donut chart showing Expense by Division',
    name: 'RP Overview - Donut Expense by Division',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
